import PropTypes from 'prop-types';
import { PassInfoDefaults, PassInfoProps } from './passInfo';
import { ExpirationTypes } from '../constants';

const passProps = {
  id: PropTypes.string,
  account_id: PropTypes.string,
  order_id: PropTypes.string,
  pass_type_id: PropTypes.string,
  facility_id: PropTypes.string,
  pass_info: PassInfoProps,
  valid_from: PropTypes.string,
  valid_to: PropTypes.string,
  sale_date: PropTypes.string,
  created_at: PropTypes.string
};

export const PassProps = PropTypes.shape(passProps);

export const PassDefaults = {
  id: '',
  account_id: '',
  order_id: '',
  pass_type_id: '',
  facility_id: '',
  pass_info: PassInfoDefaults,
  valid_from: '',
  valid_to: '',
  sale_date: '',
  created_at: ''
};

export const ExpiredPassProps = PropTypes.shape({
  ...passProps,
  type: PropTypes.oneOf(ExpirationTypes),
  message: PropTypes.string
});

export const ExpiredPassDefaults = {
  ...PassDefaults,
  type: 'expired',
  message: ''
};
